export default function isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
